import {UiDocumentListPreview} from "./UiDocumentListPreview";
import {EntityType} from "../Types";

export type BuSubjectAddress = {
	city: string,
	cityPart: string,
	cityCityPart: string,
	street: string,
	numD: string,
	numO: string,
	zip: string,
}

export type BuSubject = {
	 id: number, // (autoIncrement)
	 name: string, // [500]
	 internalCode: string|null, // [10]
	 ic: string, // [20]
	 dic: string, // [20]
	 address: BuSubjectAddress, // (json)
	 headerInfo: BuSubjectHeaderInfo, // (json)
}

export type BuSubjectHeaderInfo = {
	representativeFirstName: string,
	representativeLastName: string,
	courtName: string,
	courtTract: string,
}

export type DmsDocumentTypeOpts = {
	fields?: Record<string, DmsDocumentTypeOpsField>,
	attachTypes?: string[]|null,
	subDocumentTypes: string[],
}

export type DmsDocumentTypeOpsField = {
	visible?: boolean,
	label?: string,
}

export type DocumentListPreviewOpt = {
	label: string,
	filterField: string,
}

export type DmsDocument = any;

export const documentListPreviewOpts: Record<EntityType, DocumentListPreviewOpt> = {
	BuSubject: {
		filterField: "partnerBuSubjectId",
		label: "Dokumenty subjektu "
	},
	OrgProject: {
		filterField: "orgProjectId",
		label: "Dokumenty projektu "
	},
	Responsible: {
		filterField: "responsibleId",
		label: "Dokumenty uživatele "
	},
	Parent: {
		filterField: "parentId",
		label: "Dodatky "
	}
}

export type DmsAttach = {
	id: number,
	fileName: string,
	downloadLink: string,
}

export type EContractFilter = "supplier"|"customer"|"";

export const ContractFilter: Record<EContractFilter, string> = {
	"": "Seznam subjektů",
	customer: "Zákazníci",
	supplier: "Dodavatelé",
}
export type EntityLisResponse<T = any> = {
	fullCount: number,
	list: T[]
}

export type DmsDocumentType = {
	opts: DmsDocumentTypeOpts,
	default: DmsDocument,
	id : number,
	name: string,
	code: string,
	mustHaveParent: boolean,
	workflowId: number,
	dmsDocumentClassGroupId: number,
	[s: string]: any
}

export type OrgProject = {
	id: number, // (autoIncrement)
	name: string, // [200]
	code: string, // [100]
	orgDivisionId: number, //
}
